import React from "react";
import { connect } from "react-redux";

import Config from "../../config";
import { makeStyles } from "@material-ui/core/styles";

import Button from "@material-ui/core/Button";
import InputLabel from "@material-ui/core/InputLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

import { CLIO_AUTH } from "../../constants";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(5),
    height: "250px",
    position: "relative",
  },
  block: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  logo: {
    fill: theme.palette.type === "dark" ? "white" : "black",
  },
  formControl: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(4),
    minWidth: 120,
    maxWidth: 200,
  },
  button: {
    position: "absolute",
    bottom: "5px",
    width: "120px",
    margin: theme.spacing(4),
  },
}));
const REGIONS = {
  US: "us",
  CANADA: "ca",
  EUROPE: "eu",
  Australia: "au",
};

const REGION_PREFIX = {
  us: "",
  eu: "eu.",
  ca: "ca.",
  au: "au.",
};

function AuthenticateClioAlasql({ userId, authData, origin }) {
  const [region, setRegion] = React.useState(REGIONS.US);
  const classes = useStyles();
  const isDev = process.env.REACT_APP_STAGE !== "production";

  // TODO need to handle proper region authentication
  const authenticate = async () => {
    window.location.href = `https://${REGION_PREFIX[region]}app.clio.com/oauth/authorize?response_type=code&client_id=${
      Config[`${REGION_PREFIX[region]}id`]
    }&redirect_uri=${Config.redirectUri}&state=${JSON.stringify({
      region: region === REGIONS.US ? "" : region,
      userId: userId || authData.username,
      authData: {
        attributes: authData?.attributes || {},
      },
      type: CLIO_AUTH,
      engine: "alasql",
      origin,
      isDev,
    })}`;
  };

  const handleRegionChange = (event) => {
    setRegion(event.target.value);
  };

  return (
    <div className={classes.root}>
      <div className={classes.block}>
        <svg
          className={classes.logo}
          width="191"
          height="30"
          viewBox="0 0 191 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path d="M25.1302 5.33766L27.8964 1.48052L24.4678 4.55844C21.8964 1.79221 18.2341 0.0584412 14.1626 0.0584412C6.4094 0.0584412 0.117188 6.35065 0.117188 14.1039C0.117188 21.8571 6.4094 28.1493 14.1626 28.1493C21.9159 28.1493 28.2081 21.8571 28.2081 14.1039C28.1886 10.7727 27.0393 7.73376 25.1302 5.33766ZM23.9224 18.7013C23.9224 21.526 21.6237 23.8247 18.799 23.8247H9.52628C6.70161 23.8247 4.4029 21.526 4.4029 18.7013V9.42857C4.4029 6.60389 6.70161 4.30519 9.52628 4.30519H18.799C20.3575 4.30519 21.7601 5.00649 22.7146 6.11688L14.1237 13.7922L8.29901 9.83766L12.5068 17.961C12.5263 18 12.5652 18.039 12.6042 18.0974C12.6237 18.1169 12.6432 18.1364 12.6626 18.1558C12.7016 18.2143 12.7406 18.2727 12.7795 18.3312C12.8185 18.3701 12.8769 18.4091 12.9159 18.4481C13.4613 18.9351 14.1626 19.0909 14.8445 18.9351H14.8639C14.9808 18.8961 15.0977 18.8571 15.2146 18.8182C15.2341 18.8182 15.2536 18.7987 15.273 18.7987C15.3704 18.7403 15.4678 18.7013 15.5652 18.6234C15.6042 18.6039 15.6237 18.5844 15.6432 18.5649C15.6821 18.526 15.7406 18.5065 15.7795 18.4675C15.8185 18.4286 15.838 18.4091 15.8769 18.3701C15.8964 18.3506 15.9159 18.3506 15.9159 18.3312L15.9549 18.2727C16.0133 18.1948 16.0717 18.1364 16.1107 18.0584L23.5717 7.61688C23.8055 8.2013 23.9419 8.84415 23.9419 9.50649V18.7013H23.9224Z" />
            <path d="M88.1308 12.7792C87.2932 12.7792 86.6113 12.0974 86.6113 11.2597C86.6113 10.4221 87.2932 9.74023 88.1308 9.74023C88.9685 9.74023 89.6503 10.4221 89.6503 11.2597C89.6698 12.0779 88.988 12.7792 88.1308 12.7792ZM88.1308 9.99348C87.449 9.99348 86.8841 10.5584 86.8841 11.2402C86.8841 11.9221 87.449 12.487 88.1308 12.487C88.8126 12.487 89.3776 11.9221 89.3776 11.2402C89.3776 10.5584 88.8321 9.99348 88.1308 9.99348Z" />
            <path d="M88.404 12L88.1118 11.4545H87.8585V12H87.5273V10.4805H88.2481C88.5598 10.4805 88.7546 10.6948 88.7546 10.9675C88.7546 11.2402 88.5793 11.3766 88.4235 11.4156L88.7741 12H88.404ZM88.4235 10.9675C88.4235 10.8311 88.326 10.7532 88.1897 10.7532H87.8585V11.1623H88.2092C88.326 11.1818 88.4235 11.1039 88.4235 10.9675Z" />
            <path d="M46.5785 24.1363C40.1695 24.1363 35.8643 20.0844 35.8643 14.0454C35.8643 8.10388 40.2669 3.95453 46.5785 3.95453C50.7279 3.95453 52.8902 5.55193 53.4357 6.01946L52.15 9.33115C51.3318 8.64933 49.3058 7.46102 46.8513 7.46102C42.9162 7.46102 40.2669 10.0714 40.2669 13.9675C40.2669 17.7857 42.9746 20.4545 46.8513 20.4545C49.6565 20.4545 51.4487 19.3441 52.4032 18.526L53.7863 21.6428C52.0136 23.2987 49.598 24.1363 46.5785 24.1363Z" />
            <path d="M60.0201 4.24673H55.7539V23.7857H60.0201V4.24673Z" />
            <path d="M63.2345 23.7857V9.99349H67.5007V23.7857H63.2345ZM65.3773 7.73376C63.8773 7.73376 62.9033 6.89609 62.9033 5.61038C62.9033 4.34414 63.8968 3.487 65.3773 3.487C66.8579 3.487 67.8514 4.34414 67.8514 5.61038C67.8319 6.89609 66.8773 7.73376 65.3773 7.73376Z" />
            <path d="M77.7672 24.0974C72.9555 24.0974 69.7412 21.2143 69.7412 16.9286C69.7412 12.6234 72.975 9.72076 77.7672 9.72076C82.5594 9.72076 85.7737 12.6234 85.7737 16.9286C85.7737 21.2143 82.5594 24.0974 77.7672 24.0974ZM77.7672 12.8182C75.5464 12.8182 74.0659 14.4351 74.0659 16.8506C74.0659 19.2662 75.5464 20.8831 77.7672 20.8831C79.988 20.8831 81.4685 19.2662 81.4685 16.8506C81.4685 14.4351 79.988 12.8182 77.7672 12.8182Z" />
            <path d="M117.312 24.0779H115.715L113.981 6.44804L106.481 24.4286H106.325L98.8059 6.42856L97.1306 24.0779H95.5332L97.5981 3.77921H99.4293L106.403 21.0974L113.397 3.77921H115.247L117.312 24.0779Z" />
            <path d="M130.988 24.0779H129.429V22.1688C128.923 22.7532 127.462 24.3701 124.812 24.3701C122.163 24.3701 120.254 22.5974 120.254 20.2597C120.254 17.9221 122.027 16.2857 125.689 16.1493L129.429 15.9935V15.2532C129.429 12.7597 127.754 11.513 125.611 11.513C123.488 11.513 121.871 12.448 121.579 12.6818L120.994 11.5714C121.871 10.987 123.488 10.1883 125.553 10.1883C127.618 10.1883 128.845 10.8312 129.663 11.7273C130.462 12.6039 130.988 13.6363 130.988 15.9935V24.0779V24.0779ZM129.429 17.1623L125.553 17.3961C122.708 17.5519 121.793 18.7792 121.793 20.2402C121.793 21.7013 122.903 23.026 125.124 23.026C127.345 23.026 128.806 21.5649 129.449 20.5325V17.1623H129.429Z" />
            <path d="M145.286 24.0779H143.728V15.9935C143.728 13.7922 143.338 11.513 140.397 11.513C137.455 11.513 136.053 14.0649 136.053 17.2987V24.0584H134.514V10.4026H136.053V12.9351C136.734 11.3182 138.488 10.1688 140.475 10.1688C144.39 10.1688 145.306 12.6623 145.306 15.8961V24.0779H145.286Z" />
            <path d="M158.961 24.0779H157.403V22.1688C156.896 22.7532 155.435 24.3701 152.786 24.3701C150.137 24.3701 148.228 22.5974 148.228 20.2597C148.228 17.9221 150 16.2857 153.663 16.1493L157.403 15.9935V15.2532C157.403 12.7597 155.728 11.513 153.585 11.513C151.461 11.513 149.844 12.448 149.552 12.6818L148.968 11.5714C149.844 10.987 151.461 10.1883 153.526 10.1883C155.591 10.1883 156.818 10.8312 157.637 11.7273C158.435 12.6039 158.961 13.6363 158.961 15.9935V24.0779V24.0779ZM157.403 17.1623L153.526 17.3961C150.682 17.5519 149.766 18.7792 149.766 20.2402C149.766 21.7013 150.877 23.026 153.098 23.026C155.318 23.026 156.779 21.5649 157.422 20.5325V17.1623H157.403Z" />
            <path d="M174.838 21.1363C174.838 24.2338 174.449 25.8506 173.728 27.0195C172.988 28.1883 171.371 29.961 167.845 29.961C164.319 29.961 162.117 27.8961 162.117 27.8961L162.994 26.7273C163.734 27.4675 165.78 28.5779 168.001 28.5779C170.221 28.5779 171.527 27.6039 172.111 26.8052C172.695 25.987 173.28 24.5065 173.28 22.1493V21.1558C172.286 22.9286 170.572 24.0584 168.137 24.0584C164.552 24.0584 161.455 21.3896 161.455 17.1234C161.455 12.8571 164.552 10.1883 168.137 10.1883C170.572 10.1883 172.364 11.3961 173.28 13.013V10.4221H174.838V21.1363ZM168.215 11.5519C164.825 11.5519 163.072 14.026 163.072 17.1039C163.072 20.2013 164.845 22.6948 168.215 22.6948C171.585 22.6948 173.358 20.2013 173.358 17.1039C173.377 14.026 171.604 11.5519 168.215 11.5519Z" />
            <path d="M190.345 17.6104H179.26C179.416 20.8441 181.228 22.987 184.325 22.987C187.423 22.987 189.118 21.2143 189.118 21.2143L189.858 22.3052C189.858 22.3052 188.144 24.3701 184.189 24.3701C180.215 24.3701 177.663 21.4285 177.663 17.2597C177.663 13.0519 180.663 10.2078 184.286 10.2078C187.871 10.2078 190.462 12.9156 190.462 16.5974C190.423 17.0259 190.345 17.6104 190.345 17.6104ZM188.864 16.2857C188.864 14.513 187.54 11.513 184.15 11.513C180.76 11.513 179.377 14.3571 179.299 16.2857H188.864Z" />
          </g>
        </svg>

        <FormControl required className={classes.formControl}>
          <InputLabel htmlFor="region-required">Region</InputLabel>
          <Select
            native
            value={region}
            onChange={handleRegionChange}
            name="Region"
            inputProps={{
              id: "region-required",
            }}
          >
            <option value={REGIONS.US}>US</option>
            <option value={REGIONS.CANADA}>Canada</option>
            <option value={REGIONS.EUROPE}>Europe</option>
            <option value={REGIONS.Australia}>Australia</option>
          </Select>
          <FormHelperText>Required</FormHelperText>
        </FormControl>
        <Button className={classes.button} variant="contained" color="primary" onClick={authenticate}>
          Authenticate
        </Button>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({ userId: state.cognito.username });

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AuthenticateClioAlasql);
